import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import { Design} from '../designTest/designTest.model';

export interface TokenPayload {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  phone: string;
  type: string;
}

export interface UserDetails {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  // confirmpassword: string;
  phone: string;
  type;
  exp: number;
  iat: number;
}
interface TokenResponse {
  token: string;
}

export interface TestData {
  id: string;
  FirstName: string;
  LastName: string;
  Email: string;
  Phone: string;
  Type: string;
}

@Injectable()
export class TestTakerService {
  private token: string;
  constructor(private http: HttpClient) {}
  private saveToken( token: string): void {
    localStorage.setItem('userToken', token);
    this.token = token;
    //
  }

  private getToken(): string {
    if (!this.token) {
      this.token = localStorage.getItem('userToken');
      //
    }
    return this.token;
  }

  public getUserDetails(): UserDetails {
    const token = this.getToken();
    let payload;
    if (token) {
      //
      payload = token.split('.')[1];
      payload = window.atob(payload);
      return JSON.parse(payload);
    } else {
      return null;
    }
  }

  public isLoggedIn(): boolean {
    const user = this.getUserDetails();
    if (user) {
      return user.exp > Date.now() / 1000;
    } else {
      return false;
    }
  }
  // UI
  getColumns(): string[] {
    return ['FIRST NAME', 'LAST NAME', 'E-MAIL', 'PHONE NUMBER', 'EDIT', 'DELETE'];
  }
  getSAColumns(): string[] {
    return ['FIRST NAME', 'LAST NAME', 'E-MAIL', 'PHONE NUMBER', 'EDIT'];
  }

  // CreateTestTaker
  public createTestTaker(user: TokenPayload): Observable<any> {
    const b = this.http.post('/users/createTestTaker', user);
    const request = b.pipe(
      map((data: TokenResponse) => {


        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

    // display test_taker:
    public test_taker(user: TestData): Observable<any> {
      const base = this.http.post('/users/test_taker', user);
      //
      const request = base.pipe(
        map((data: TokenResponse) => {


          // if (data.token) {
          //   this.saveToken(data.token);
          // }
          return data;
        })
      );
      return request;
    }


 //  edit_test_taker
  public  edit_test_taker(id): Observable<any> {

    var body = {
      id:id
    }
    const base = this.http.post('/users/edit_test_taker', body);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }


  // update_test_taker
  public update_test_taker(user: TokenPayload): Observable<any> {

    const b = this.http.post('/users/update_test_taker', user);
    const request = b.pipe(
      map((data: TokenResponse) => {

        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }


  // delete
  public delete_test_taker(user: TokenPayload): Observable<any> {

    const base = this.http.post('/users/delete_test_taker', user);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }




}
